export function useLocations() {
	// fetch locations
	async function fetch(options, config = {}) {
		return await useApi(
			'/api/nuxtapi/location/points/',
			{
				method: 'POST',
				body: options,
			},
			{cache: true, key: options, ...config}
		);
	}

	return {fetch};
}
